import axios from 'axios'
import router from '@/router'
import store from '@/store'
import Notification from 'vue-atlas/src/Notification/VaNotificationMethod'
import Vue from 'vue'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_URL}api`,
  // baseURL: 'http://localhost:3000/api',
  // timeout: 1000,
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Origin': process.env.BASE_URL,
    'Access-Control-Allow-Headers': 'accept',
  },
  // headers: {
  //   Accept: 'application/json',
  //   'Content-Type': 'application/json',
  // },
})

apiClient.interceptors.request.use(
  config => {
    store.dispatch('LOADING', true)
    return config
  },
  error => {
    store.dispatch('LOADING', false)
    return Promise.reject(error)
  },
)

apiClient.interceptors.request.use(request => {
  // console.log('data store', store.state, request)
  // console.log(request)
  // console.log(apiClient)
  const sessionId = Vue.$cookies.get('sessionId')
  // console.log(user, request)
  if (sessionId) {
    // TEMPORARY
    const user = Vue.$cookies.get('user')
    if (user) {
      if (!request.params) request.params = {}
      // request.params.idUser = user.id
    }
    //

    // request.headers.Authorization = `Bearer ${accessToken}`
    // request.headers.AccessToken = accessToken
  }
  // store.dispatch('LOADING', true)
  return request
})

apiClient.interceptors.response.use(
  response => {
    store.dispatch('LOADING', false)
    return response
  },
  error => {
    store.dispatch('LOADING', false)
    return Promise.reject(error)
  },
)

apiClient.interceptors.response.use(undefined, error => {
  // Errors handling
  const { response } = error
  const data = response ? response.data : null
  // console.log(data, response, ',,,')
  store.dispatch('LOADING', false)
  if (data) {
    const title = data.status ? data.status.split('_').join(' ') : 'Sedang Terjadi Error. Coba Lagi Nanti'
    const { message } = data
    Notification.danger({
      title,
      message,
      duration: 3000,
    })
    if (data.status === 'SESSION_TIMEOUT') {
      Vue.$cookies.remove('sessionId')
      Vue.$cookies.remove('user')
      return router.push('/masuk')
    }
  } else {
    Notification.danger({
      title: 'Internal Server Error',
      message: 'There must be some error. Please try again later.',
      duration: 3000,
    })
  }
  // console.log(data, error.response, 'error')
  // console.log(Notification)
  // console.log(Notification, 'tes')
  // }
})

export default apiClient
